import { render } from "./presenca-turmas.vue?vue&type=template&id=74bb613a&scoped=true"
import script from "./presenca-turmas.vue?vue&type=script&lang=js"
export * from "./presenca-turmas.vue?vue&type=script&lang=js"

import "./presenca-turmas.vue?vue&type=style&index=0&id=74bb613a&lang=scss&scoped=true"
import "./presenca-turmas.vue?vue&type=style&index=1&id=74bb613a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bb613a"]])

export default __exports__